// src/pages/AfterSignup.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const AfterSignup = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        navigate("/");
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="bg-white shadow-md rounded-lg max-w-lg p-8 text-center">
                <h2 className="text-2xl font-semibold text-green-700 mb-4">
                    Merci pour votre préinscription !
                </h2>
                <p className="text-gray-700 mb-6">
                    Un e-mail de confirmation a été envoyé à votre adresse. Veuillez cliquer sur le lien de vérification pour valider votre inscription.
                    <br /><br />
                    Une fois votre adresse confirmée, notre équipe examinera votre dossier. Vous recevrez vos identifiants de connexion sous 24 heures.
                </p>
                <button
                    onClick={handleReturnHome}
                    className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition duration-200"
                >
                    Retour à l'accueil
                </button>
            </div>
        </div>
    );
};

export default AfterSignup;
